import React from 'react'
import { Row, Col } from 'reactstrap'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import moment from '../../lib/moment.js'
import KawariTeamLeave from '../../components/kawari-calendar/team-leave'
import {
  Leave,
  Compensate,
  Holiday,
} from '../../components/my-leave/modal'
import * as CONSTANTS from '../../components/my-leave/constants'
import { findUserData, findProjectData } from '../../components/my-leave/helpers/my-leave'

export const Calendar = class extends React.Component {
  state={ showDetail: false }

  showRequestDetail = (dataType, data) => {
    if (dataType === CONSTANTS.HOLIDAY || dataType === CONSTANTS.COMPENSATE) {
      this.setState({ dataType, data: this.changeDataFormat(dataType, data) })
    } else {
      this.setState({ dataType: CONSTANTS.LEAVE, data: this.changeDataFormat(dataType, data) })
    }
  }

  changeDataFormat = (dataType, data) => {
    switch (dataType) {
      case CONSTANTS.HOLIDAY: {
        const holiday = {}
        holiday.holiday_name = get(data, 'description')
        return holiday
      }
      case CONSTANTS.COMPENSATE: {
        const users = get(this.props, 'users', [])
        const projects = get(this.props, 'projects', [])
        const compensates = []
        data.map(d => {
          const compensate = {}
          const user = findUserData(get(d, 'user_id'), users)
          const approver = findUserData(get(d, 'approver_id'), users)
          const project = findProjectData(get(d, 'project_id'), projects)
          compensate.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          compensate.project = project ? `${project.project_code} - ${project.project_name}` : '-'
          compensate.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          compensate.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          compensate.compensate_time = get(d, 'compensate_time')
          compensate.days = get(d, 'days')
          compensate.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          compensate.status = get(d, 'status')
          compensate.remark_request_user = get(d, 'remark_request_user')
          compensate.remark_approver = get(d, 'remark_approver')
          compensate.remark_cancel = get(d, 'remark_cancel')
          compensates.push(compensate)
          return d
        })
        return orderBy(compensates, 'compensate_time', 'asc')
      }
      default: {
        const users = get(this.props, 'users', [])
        const leaveTypes = get(this.props, 'leaveTypes', [])
        const leaves = []

        data.map(d => {
          const user = findUserData(get(d, 'user_id'), users)
          const approver = findUserData(get(d, 'approver_id'), users)
          const leave_type = findUserData(get(d, 'leave_type_id'), leaveTypes)
          const leave = {}
          leave.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          leave.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          leave.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          leave.leave_type = get(leave_type, 'name')
          leave.leave_time = get(d, 'leave_time')
          leave.created = moment(get(d, 'created')).format('DD/MM/YYYY')
          leave.days = get(d, 'days')
          leave.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          leave.status = get(d, 'status')
          leave.attachment_url = get(d, 'attachment_url')
          leave.remark_request_user = get(d, 'remark_request_user')
          leave.remark_approver = get(d, 'remark_approver')
          leave.remark_hr = get(d, 'remark_hr')
          leave.remark_cancel = get(d, 'remark_cancel')
          leaves.push(leave)
          return d
        })
        return orderBy(leaves, 'leave_time', 'asc')
      }
    }
  }

  handleClickCell = (dataType, data) => {
    this.setState({ showDetail: !this.state.showDetail })
    if (!this.state.showDetail) {
      if (dataType) {
        this.showRequestDetail(CONSTANTS.HOLIDAY, data)
      } else {
        let type = CONSTANTS.LEAVE
        if (get(data, 'events')[0].compensate_time) type = CONSTANTS.COMPENSATE
        this.showRequestDetail(type, data.events)
      }
    } else {
      this.setState({ dataType: null, data: {} })
    }
  }

  render() {
    const props = this.props
    return (
      <Row>
        <Col>
          <Leave
            showDetail={ this.state.dataType === CONSTANTS.LEAVE }
            handleDetail={ this.handleClickCell }
            data={ this.state.data }
          />
          <Compensate
            showDetail={ this.state.dataType === CONSTANTS.COMPENSATE }
            handleDetail={ this.handleClickCell }
            data={ this.state.data }
          />
          <Holiday
            showDetail={ this.state.dataType === CONSTANTS.HOLIDAY }
            handleDetail={ this.handleClickCell }
            { ...this.state.data }
          />
          { get(props, 'myLeaveRequests') && get(props, 'myCompensateRequestsHistory') &&
          <div
            style={ {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              padding: 10,
              paddingTop: 0,
            } }
          >
            <KawariTeamLeave
              data={ get(props, 'myLeaveRequests') }
              publicHoliday={ get(props, 'publicHoliday') }
              moment={ get(props, 'moment') }
              range={ get(props, 'range') }
              handleClickCell={ this.handleClickCell }
              teamCalendar={ false }
              myUser={ get(props, 'myUser') }
              users={ get(props, 'users') }
              myCompensate={ get(props, 'myCompensateRequestsHistory') }
              findFullNameByID={ props.findFullNameByID }
            />
          </div>
          }
        </Col>
      </Row >
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-leave/calendar.js